import React, { useEffect } from 'react';
import parse from 'html-react-parser';
import { useAppSelector } from '../store/hooks';
import { useSwipe } from '../store/useSwipe';
import fetchData from 'Utilis/request';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const PrivacyPolicy: React.FC = () => {
const { onTouchStart, onTouchMove, onTouchEnd } = useSwipe();
    const darkMode = useAppSelector((state: any) => state.categoryNavigation.darkmode);
    const headerHeight = useAppSelector((state: any) => state.categoryNavigation.headerHeight || 0);
    const fooNavHeight = useAppSelector((state: any) => state.categoryNavigation.fooNavHeight || 0);
    const fontSize = useAppSelector((state: any) => state.categoryNavigation.fontsize);    
    
    const [policyData, setPolicyData] = React.useState<any>(null);
    const [loading, setLoading] = React.useState(true); 
    
    

const fetchDetails = async () => {    
    setLoading(true);

    try {      
       const data = await fetchData.getResult(`${API_BASE_URL}getPages.php?page=privacy`);  
      
      if (!data?.success) {
        throw new Error('No data received from API');
      }

      const content = data?.content || '';     
   

      setPolicyData(content);
      
    } catch (err:any) {
      console.error("Error fetching details:", err);     
 

    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetails();
   
  }, []);

  return (
     <div className={`font-sans min-h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>
        <main
        className="home-container"       
       style={{ height: `calc(100vh - ${fooNavHeight+10}px)`, overflowY: 'auto', paddingTop:headerHeight+10}}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}>
    
      <div className="max-w-4xl mx-auto space-y-4 px-3">

        {/* Page Header */}
        <h1 className={`font-bold mb-0 ${fontSize === 'small' ? 'text-lg' : fontSize === 'large' ? 'text-2xl' : 'text-xl'}`}>
                      {"Privacy Policy"}
        </h1>

        {/* Directors Block */}
        <div className={`rounded-2xl shadow-md py-4 px-2 md:p-10 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
         {parse(policyData || '')}
        </div>

       
      </div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;